// Generated by purs version 0.15.15
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as StringParser_Parser from "../StringParser.Parser/index.js";
import * as Text_Email_Parser from "../Text.Email.Parser/index.js";
var runEmailParser = function (s) {
    return StringParser_Parser.runParser(Text_Email_Parser.addrSpec)(s);
};
var validate = /* #__PURE__ */ (function () {
    var $22 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(Data_Show.show(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "error";
        }
    })(Data_Show.showRecordFieldsConsNil({
        reflectSymbol: function () {
            return "pos";
        }
    })(Data_Show.showInt))(Data_Show.showString))));
    return function ($23) {
        return $22(runEmailParser($23));
    };
})();
var isValid = function (emailString) {
    var v = validate(emailString);
    if (v instanceof Data_Either.Left) {
        return false;
    };
    if (v instanceof Data_Either.Right) {
        return true;
    };
    throw new Error("Failed pattern match at Text.Email.Validate (line 35, column 5 - line 37, column 25): " + [ v.constructor.name ]);
};
var emailAddress = function (emailString) {
    var v = validate(emailString);
    if (v instanceof Data_Either.Left) {
        return Data_Maybe.Nothing.value;
    };
    if (v instanceof Data_Either.Right) {
        return new Data_Maybe.Just(v.value0);
    };
    throw new Error("Failed pattern match at Text.Email.Validate (line 22, column 5 - line 24, column 35): " + [ v.constructor.name ]);
};
var canonicalizeEmail = /* #__PURE__ */ (function () {
    var $24 = Data_Functor.map(Data_Maybe.functorMaybe)(Text_Email_Parser.toString);
    return function ($25) {
        return $24(emailAddress($25));
    };
})();
export {
    isValid,
    validate,
    emailAddress,
    canonicalizeEmail,
    runEmailParser
};
export {
    EmailAddress,
    addrSpec,
    domainPart,
    localPart,
    toString
} from "../Text.Email.Parser/index.js";
//# sourceMappingURL=index.js.map
